import { ImprUserDropdown } from '@imprivata-cloud/components';
import { Layout } from 'antd';
import { useEffect, type PropsWithChildren } from 'react';
import { useLocalLogout, useLogout } from '@portal/hooks/useLogout';
import { useIdleTimeout } from '@portal/hooks/useIdleTimeout';
import { SELF_SERVICE_TIMEOUT } from '@portal/constants';
import ImprivataLogo from '@assets/Imprivata_Logo.svg?react';
import ImprivataDefaultLogo from '@assets/default_logo.svg';
import './SelfServiceLayout.less';
import useAgentWindow from '@hooks/useAgentWindow';

const { Header, Content, Footer } = Layout;

export interface SelfServiceLayoutProps {
  username: string;
  email: string;
  logoUrl: string;
}

const SelfServiceLayout = ({ children, username, logoUrl, email }: PropsWithChildren<SelfServiceLayoutProps>) => {
  useAgentWindow(['beforeunload']);

  const hasLogoUrl = logoUrl !== '';
  const handleLocalLogout = useLocalLogout();
  const handleLogout = useLogout();
  const { startIdleTimer, stopIdleTimer } = useIdleTimeout(SELF_SERVICE_TIMEOUT, handleLocalLogout);

  useEffect(() => {
    startIdleTimer();
    return () => {
      stopIdleTimer();
    };
  }, [startIdleTimer, stopIdleTimer]);

  return (
    <div className="self-service-page">
      <Layout className="self-service-layout">
        <Header className="self-service-header">
          <div className="header-content">
            <div className="logo-container"><ImprivataLogo /></div>
            <ImprUserDropdown username={username} email={email} onLogout={handleLogout} aria-label={'user-menu'} />
          </div>
        </Header>

        <Layout className="content-layout">
          <Content className="self-service-content">{children}</Content>
        </Layout>

        <Footer className="self-service-footer">
          {hasLogoUrl ? <img src={logoUrl} alt="logo" /> : <img src={ImprivataDefaultLogo} alt="default-logo" />}
          <div className="footer-right">My Imprivata Identity</div>
        </Footer>
      </Layout>
    </div>
  );
};

export default SelfServiceLayout;
